/* YWV collection grid v2 (A/B treatment). Vanilla JS, no dependencies.
   1. Stars on every card: ONE Stamped "badges" call per batch of cards, each design's
      OWN rating and count (never the pooled store total).
   2. Reviews popup: that design's own reviews + customer photos + a "With media"
      filter. A design with no reviews shows clearly labelled reviews of the most
      reviewed design on the page instead.
   3. Add to cart: sizes first (Style, Sole, Size), then the theme's own cart drawer.
   4. "Load more designs": fetches the next page's section HTML and appends the cards;
      coming Back to the page restores the loaded pages and the scroll position.
   Everything lives under [data-ywv2]; if that isn't on the page, nothing runs. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ywv2]');
  if (!root) return;

  var STAMPED_KEY = (document.getElementById('stamped-script-widget') || {}).dataset
    ? document.getElementById('stamped-script-widget').dataset.apiKey : '';
  var SHOP = (window.Shopify && window.Shopify.shop) || location.host;
  var BADGES = {}; // productId -> { rating, count, breakdown }
  var BAG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 7h12l-1 13H7L6 7z" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/><path d="M9 7a3 3 0 0 1 6 0" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';

  function h(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function stars(v) { var pct = Math.max(0, Math.min(100, (v / 5) * 100)).toFixed(1); return '<span class="ywv2-stars" aria-hidden="true">★★★★★<b style="width:' + pct + '%">★★★★★</b></span>'; }
  function money(cents) { try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', minimumFractionDigits: cents % 100 ? 2 : 0 }); } catch (e) { return '$' + (cents / 100).toFixed(0); } }
  function day(s) { var d = new Date(s); return isNaN(d) ? '' : d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }); }
  function shortName(n) { var p = String(n || '').trim().split(/\s+/).filter(Boolean); if (!p.length) return 'Verified buyer'; return p.length > 1 ? p[0] + ' ' + p[p.length - 1].charAt(0).toUpperCase() + '.' : p[0]; }
  // Some file names carry a ?v= version tag: keep it as a query, only encode the name itself.
  function photoUrl(f) { var p = String(f).trim().split('?'); return 'https://cdn.stamped.io/uploads/photos/' + encodeURIComponent(p[0]) + (p[1] ? '?' + p[1] : ''); }

  /* The product TYPE's combined rating ("Sneakers": 4.8 from 2,863), from any card of that
     type that carries Stamped's reviews metafields. Used only for designs with no reviews. */
  var VARIANTS = {};
  function readVariants(doc) {
    [].forEach.call((doc || document).querySelectorAll('[data-ywv2-variants]'), function (sc) {
      try { var j = JSON.parse(sc.textContent || '{}'); Object.keys(j).forEach(function (k) { VARIANTS[k] = j[k]; }); } catch (e) {}
    });
  }
  readVariants(document);
  // Same shape as /products/<handle>.js, built from the page's own data (no network).
  function productFromPage(handle, title) {
    var d = VARIANTS[handle]; if (!d || !d.v || !d.v.length) return null;
    var n = (d.o || []).length || 1;
    return {
      title: title, type: d.t, options: d.o || [],
      variants: d.v.map(function (x) { return { id: x[0], options: [x[1], x[2], x[3]].slice(0, n), available: !!x[4], price: x[5], compare_at_price: x[6] || null }; })
    };
  }
  var TYPES = {};
  function readTypes(doc) {
    [].forEach.call((doc || document).querySelectorAll('[data-ywv2-types]'), function (sc) {
      try { var j = JSON.parse(sc.textContent || '{}'); Object.keys(j).forEach(function (k) { if (!TYPES[k] && j[k].count > 0) TYPES[k] = j[k]; }); } catch (e) {}
    });
  }
  readTypes(document);
  function typeInfo(type) {
    if (TYPES[type]) return { rating: Number(TYPES[type].rating) || 0, count: Number(TYPES[type].count) || 0, b: TYPES[type].b || null };
    var el = null;
    [].some.call(document.querySelectorAll('[data-ywv2-card][data-type-count]'), function (c) { if (c.getAttribute('data-type') === type) { el = c; return true; } return false; });
    if (!el) return null;
    var rating = parseFloat(el.getAttribute('data-type-rating')), count = parseInt(el.getAttribute('data-type-count'), 10);
    return rating > 0 && count > 0 ? { rating: rating, count: count } : null;
  }
  // "Sneakers" -> "sneaker", "boots" -> "boot", "Hooded Blankets" -> "hooded blanket"
  // Friendly singular noun for a product type. Prefer the collection's own name for its main
  // type ("Winter Sneakers" -> "winter sneaker"); otherwise split joined store types
  // ("Wintervibesneakers" -> "wintervibe sneaker", "Comfyboots" -> "comfy boot").
  function typeNoun(type) {
    var t = String((TYPES[type] && TYPES[type].label) || type || 'product').trim().toLowerCase();
    t = t.replace(/([a-z])(sneakers|boots|shoes|slippers|jackets|blankets|hoodies|sandals|slipons)$/, '$1 $2');
    return t.length > 3 && /s$/.test(t) && !/ss$/.test(t) ? t.slice(0, -1) : t;
  }
  function fmtCount(n) { return Number(n).toLocaleString('en-US'); }

  /* ---------------- 1. stars on cards ---------------- */
  function cardsNeedingStars(scope) { return [].slice.call((scope || root).querySelectorAll('[data-ywv2-card]:not([data-rated])')); }
  function paintStars(card) {
    var id = card.getAttribute('data-product-id'), b = BADGES[id], btn = card.querySelector('[data-ywv2-reviews]');
    card.setAttribute('data-rated', '1');
    if (!btn) return;
    if (b && b.count > 0) {
      btn.setAttribute('data-state', 'rated');
      btn.innerHTML = stars(b.rating) + '<span class="ywv2-rate-txt">' + b.rating.toFixed(1) + ' (' + b.count + ')</span>';
      btn.setAttribute('aria-label', b.rating.toFixed(1) + ' out of 5, ' + b.count + ' reviews of this design. Read reviews');
    } else {
      var type = card.getAttribute('data-type'), T = typeInfo(type);
      if (T) {
        btn.setAttribute('data-state', 'type');
        btn.innerHTML = stars(T.rating) + '<span class="ywv2-rate-txt">' + T.rating.toFixed(1) + ' · ' + fmtCount(T.count) + ' ' + h(typeNoun(type)) + ' reviews</span>';
        btn.setAttribute('aria-label', T.rating.toFixed(1) + ' out of 5 from ' + fmtCount(T.count) + ' reviews of our ' + typeNoun(type) + 's. Read reviews');
      } else {
        btn.setAttribute('data-state', 'none');
        btn.innerHTML = '';
      }
    }
  }
  function loadStars(scope) {
    var cards = cardsNeedingStars(scope);
    if (!cards.length || !STAMPED_KEY) { cards.forEach(paintStars); return Promise.resolve(); }
    var ids = cards.map(function (c) { return { productId: c.getAttribute('data-product-id') }; });
    return fetch('https://stamped.io/api/widget/badges?isIncludeBreakdown=true&isincludehtml=false', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productIds: ids, apiKey: STAMPED_KEY, storeUrl: SHOP })
    }).then(function (r) { return r.json(); }).then(function (list) {
      (list || []).forEach(function (b) { BADGES[String(b.productId)] = { rating: Number(b.rating) || 0, count: Number(b.count) || 0, breakdown: b.breakdown || {} }; });
    }).catch(function () {}).then(function () { cards.forEach(paintStars); });
  }

  /* ---------------- shared dialog helpers ---------------- */
  function makeDialog(cls) {
    var d = document.createElement('dialog'); d.className = cls; document.body.appendChild(d);
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); if (e.target.closest('[data-close]')) d.close(); });
    return d;
  }
  var rvPop = makeDialog('ywv2-pop'), atcPop = makeDialog('ywv2-pop'), lb = makeDialog('ywv2-lb');
  // A customer photo that fails to load removes its own thumbnail rather than showing a broken box.
  rvPop.addEventListener('error', function (e) { var t = e.target; if (t && t.tagName === 'IMG' && t.closest('[data-ph]')) t.closest('[data-ph]').remove(); }, true);
  function cardOf(el) { return el.closest('[data-ywv2-card]'); }
  function cardImg(card) { var i = card && card.querySelector('.ywv2-img'); return i ? i.currentSrc || i.src : ''; }

  /* ---------------- 2. reviews popup ---------------- */
  var RV = { id: null, title: '', list: [], page: 0, total: 0, done: false, filter: 'all', shown: 0, gallery: [] };
  function fetchReviews(productId, page, take) {
    var u = 'https://stamped.io/api/widget/reviews?productId=' + encodeURIComponent(productId) + '&apiKey=' + encodeURIComponent(STAMPED_KEY) +
      '&storeUrl=' + encodeURIComponent(SHOP) + '&take=' + (take || 50) + '&page=' + page;
    return fetch(u).then(function (r) { return r.json(); });
  }
  function rvItem(r, showDesign) {
    var photos = String(r.reviewUserPhotos || '').split(',').filter(Boolean);
    return '<div class="ywv2-rv">' + (showDesign ? '<span class="ywv2-of">Review of ' + h(r.productName) + '</span><br>' : '') + stars(r.reviewRating) +
      (r.reviewTitle ? '<h4>' + h(r.reviewTitle) + '</h4>' : '<div style="height:5px"></div>') +
      '<p>' + h(r.reviewMessage) + '</p>' +
      (photos.length ? '<div class="ywv2-rph">' + photos.map(function (f) { return '<button type="button" data-ph="' + h(f) + '" aria-label="View customer photo"><img src="' + photoUrl(f) + '" alt="Customer photo" loading="lazy"></button>'; }).join('') + '</div>' : '') +
      '<div class="ywv2-who"><span>' + h(shortName(r.author)) + (r.location ? ' · ' + h(r.location) : '') + '</span>' + (r.reviewVerifiedType ? '<span class="ywv2-ver">✓ Verified buyer</span>' : '') + '<span>' + h(day(r.reviewDate || r.dateCreated)) + '</span></div></div>';
  }
  function rebuildGallery() {
    RV.gallery = [];
    RV.list.forEach(function (r) { String(r.reviewUserPhotos || '').split(',').filter(Boolean).forEach(function (f) { RV.gallery.push({ f: f, r: r }); }); });
  }
  function paintReviewList() {
    var box = rvPop.querySelector('[data-rv-list]'); if (!box) return;
    var list = RV.filter === 'media' ? RV.list.filter(function (r) { return r.reviewUserPhotos; }) : RV.list;
    box.innerHTML = list.length ? list.slice(0, RV.shown).map(function (r) { return rvItem(r, false); }).join('') : '<div class="ywv2-empty">No photo reviews loaded yet.</div>';
    var more = rvPop.querySelector('[data-rv-more]');
    var canMore = RV.shown < list.length || !RV.done;
    if (more) more.hidden = !canMore;
    var strip = rvPop.querySelector('[data-rv-strip]');
    rebuildGallery();
    if (strip) {
      strip.parentElement.hidden = !RV.gallery.length;
      strip.innerHTML = RV.gallery.map(function (g) { return '<button type="button" data-ph="' + h(g.f) + '" aria-label="View customer photo"><img src="' + photoUrl(g.f) + '" alt="Customer photo" loading="lazy"></button>'; }).join('');
      var hd = rvPop.querySelector('[data-rv-strip-hd]'); if (hd) hd.textContent = 'Customer photos (' + RV.gallery.length + (RV.done ? '' : '+') + ')';
    }
    var mediaBtn = rvPop.querySelector('[data-rf="media"]');
    if (mediaBtn) { var n = RV.list.filter(function (r) { return r.reviewUserPhotos; }).length; mediaBtn.lastChild.textContent = ' With media (' + n + (RV.done ? '' : '+') + ')'; }
  }
  function loadNextReviewPage() {
    if (RV.done) return Promise.resolve();
    RV.page += 1;
    return fetchReviews(RV.id, RV.page, 50).then(function (j) {
      var data = (j && j.data) || [];
      RV.list = RV.list.concat(data); RV.total = j && j.total || RV.list.length;
      if (!data.length || RV.list.length >= RV.total) RV.done = true;
    }).catch(function () { RV.done = true; });
  }
  function openReviews(card) {
    var id = card.getAttribute('data-product-id'), title = card.getAttribute('data-title'), b = BADGES[id] || { count: 0, rating: 0, breakdown: {} };
    RV = { id: id, title: title, list: [], page: 0, total: 0, done: false, filter: 'all', shown: 6, gallery: [] };
    FB = null;
    var head = '<div class="ywv2-pop-hd"><img src="' + h(cardImg(card)) + '" alt=""><div><h2>' + h(title) + '</h2><div class="ywv2-pop-sub">' +
      (b.count ? '<b>' + b.rating.toFixed(1) + '</b> out of 5 · ' + b.count + ' review' + (b.count > 1 ? 's' : '') + ' of this design'
        : (typeInfo(card.getAttribute('data-type')) ? '<b>' + typeInfo(card.getAttribute('data-type')).rating.toFixed(1) + '</b> out of 5 · ' + fmtCount(typeInfo(card.getAttribute('data-type')).count) + ' ' + h(typeNoun(card.getAttribute('data-type'))) + ' reviews' : 'Reviews of our ' + h(typeNoun(card.getAttribute('data-type'))) + 's')) +
      '</div></div><button class="ywv2-x" data-close aria-label="Close">×</button></div>';
    var foot = '<div class="ywv2-pop-ft"><button class="ywv2-go" data-rv-buy>Add to cart</button></div>';
    if (b.count) {
      var br = b.breakdown || {}, dist = [5, 4, 3, 2, 1].map(function (s) { return Number(br['rating' + s]) || 0; }), max = Math.max.apply(null, dist) || 1;
      rvPop.innerHTML = head + '<div class="ywv2-pop-bd"><div class="ywv2-sum"><div class="ywv2-big"><b>' + b.rating.toFixed(1) + '</b>' + stars(b.rating) + '<span class="ywv2-cnt">' + b.count + ' reviews</span></div><div class="ywv2-dist">' +
        dist.map(function (n, i) { return '<div><span>' + (5 - i) + ' ★</span><i><em style="width:' + (n / max * 100) + '%"></em></i><span>' + n + '</span></div>'; }).join('') + '</div></div>' +
        '<div hidden><div class="ywv2-strip-hd" data-rv-strip-hd>Customer photos</div><div class="ywv2-strip" data-rv-strip></div></div>' +
        '<div class="ywv2-filter" role="group" aria-label="Filter reviews"><button type="button" data-rf="all" aria-pressed="true">All reviews (' + b.count + ')</button><button type="button" data-rf="media" aria-pressed="false">📷<span> With media</span></button></div>' +
        '<div data-rv-list><div class="ywv2-loading">Loading reviews…</div></div><button type="button" class="ywv2-ghostbtn ywv2-rv-more" data-rv-more hidden>Show more reviews</button></div>' + foot;
      rvPop.showModal();
      loadNextReviewPage().then(paintReviewList);
    } else {
      // No reviews of its own yet: reviews of the same product TYPE, from the three most
      // reviewed designs of that type on this page, each labelled with its design.
      var type = card.getAttribute('data-type'), noun = typeNoun(type);
      var donors = [].slice.call(root.querySelectorAll('[data-ywv2-card]'))
        .filter(function (c) { return c.getAttribute('data-type') === type && BADGES[c.getAttribute('data-product-id')] && BADGES[c.getAttribute('data-product-id')].count > 0; })
        .sort(function (x, y) { return BADGES[y.getAttribute('data-product-id')].count - BADGES[x.getAttribute('data-product-id')].count; });
      var T = typeInfo(type), summary = '';
      if (T && T.count) {
        var tb = T.b && T.b.length === 5 ? T.b : null, tmax = tb ? Math.max.apply(null, tb) || 1 : 1;
        summary = '<div class="ywv2-sum"><div class="ywv2-big"><b>' + T.rating.toFixed(1) + '</b>' + stars(T.rating) + '<span class="ywv2-cnt">' + fmtCount(T.count) + ' reviews</span></div>' +
          (tb ? '<div class="ywv2-dist">' + tb.map(function (n, i) { return '<div><span>' + (5 - i) + ' ★</span><i><em style="width:' + (n / tmax * 100) + '%"></em></i><span>' + fmtCount(n) + '</span></div>'; }).join('') + '</div>' : '<div></div>') + '</div>';
      }
      rvPop.innerHTML = head + '<div class="ywv2-pop-bd">' + summary +
        '<div class="ywv2-note">⭐ These are reviews of our ' + h(noun) + 's overall. This design is new, so it has no reviews of its own yet. Each review below shows the design it was written for.</div>' +
        '<div data-rv-fb><div class="ywv2-loading">Loading reviews…</div></div></div>' + foot;
      rvPop.showModal();
      FB = { donors: donors, next: 0, buffer: [], shown: 0, done: !donors.length, busy: false };
      rvPop.querySelector('[data-rv-fb]').insertAdjacentHTML('afterend', '<button type="button" class="ywv2-ghostbtn ywv2-rv-more" data-fb-more hidden>Show more reviews</button>');
      fbShowMore(6);
    }
    rvPop._card = card;
  }
  /* Product-type reviews pager: 3 more designs' reviews per fetch, only when needed. */
  var FB = null;
  function fbFetch() {
    var batch = FB.donors.slice(FB.next, FB.next + 3); FB.next += batch.length;
    if (!batch.length) { FB.done = true; return Promise.resolve(); }
    return Promise.all(batch.map(function (c) {
      return fetchReviews(c.getAttribute('data-product-id'), 1, 12).then(function (j) {
        return ((j && j.data) || []).filter(function (r) { return r.reviewRating >= 4 && String(r.reviewMessage || '').length > 20; })
          .map(function (r) { r.productName = r.productName || c.getAttribute('data-title'); return r; });
      }).catch(function () { return []; });
    })).then(function (lists) {
      // Interleave so the list mixes designs rather than one design's reviews in a block.
      for (var i = 0; lists.some(function (l) { return l.length > i; }); i++) lists.forEach(function (l) { if (l[i]) FB.buffer.push(l[i]); });
    });
  }
  function fbShowMore(n) {
    if (!FB || FB.busy) return;
    var fb = FB, want = fb.shown + n, box = rvPop.querySelector('[data-rv-fb]'), btn = rvPop.querySelector('[data-fb-more]');
    fb.busy = true; if (btn) { btn.textContent = 'Loading…'; btn.disabled = true; }
    (function fill() { return fb.buffer.length >= want || fb.done ? Promise.resolve() : fbFetch().then(fill); })().then(function () {
      if (FB !== fb || !box) return; // popup was reopened for another design
      fb.shown = Math.min(want, fb.buffer.length); fb.busy = false;
      RV.list = fb.buffer.slice(0, fb.shown); rebuildGallery();
      box.innerHTML = fb.shown ? RV.list.map(function (r) { return rvItem(r, true); }).join('') : '<div class="ywv2-empty">No reviews to show yet.</div>';
      if (btn) { btn.hidden = fb.done && fb.shown >= fb.buffer.length; btn.disabled = false; btn.textContent = 'Show more reviews'; }
    });
  }
  rvPop.addEventListener('click', function (e) {
    if (e.target.closest('[data-fb-more]')) { fbShowMore(6); return; }
    var f = e.target.closest('[data-rf]');
    if (f) {
      RV.filter = f.getAttribute('data-rf');
      [].forEach.call(rvPop.querySelectorAll('[data-rf]'), function (b) { b.setAttribute('aria-pressed', b === f ? 'true' : 'false'); });
      RV.shown = 6;
      // "With media" needs every page: fetch the rest (a design has at most a few hundred reviews).
      var fill = RV.filter === 'media' ? (function next() { return RV.done || RV.page >= 6 ? Promise.resolve() : loadNextReviewPage().then(next); })() : Promise.resolve();
      paintReviewList(); fill.then(paintReviewList);
      return;
    }
    if (e.target.closest('[data-rv-more]')) {
      RV.shown += 6;
      var list = RV.filter === 'media' ? RV.list.filter(function (r) { return r.reviewUserPhotos; }) : RV.list;
      (RV.shown > list.length && !RV.done ? loadNextReviewPage() : Promise.resolve()).then(paintReviewList);
      return;
    }
    var ph = e.target.closest('[data-ph]');
    if (ph) { openPhoto(ph.getAttribute('data-ph')); return; }
    if (e.target.closest('[data-rv-buy]')) { var c = rvPop._card; rvPop.close(); openAtc(c); }
  });

  /* photo viewer */
  var lbAt = 0;
  function openPhoto(file) {
    rebuildGallery();
    lbAt = Math.max(0, RV.gallery.findIndex(function (g) { return g.f === file; }));
    drawPhoto(); if (!lb.open) lb.showModal();
  }
  function drawPhoto() {
    var g = RV.gallery[lbAt]; if (!g) return; var r = g.r, one = RV.gallery.length < 2;
    lb.innerHTML = '<button class="ywv2-lb-x" data-close aria-label="Close photo">×</button><figure class="ywv2-lb-fig"><img src="' + photoUrl(g.f) + '" alt="Customer photo">' +
      (one ? '' : '<button class="ywv2-lb-nav prev" data-lb="-1" aria-label="Previous photo">‹</button><button class="ywv2-lb-nav next" data-lb="1" aria-label="Next photo">›</button>') +
      '</figure><div class="ywv2-lb-n">Photo ' + (lbAt + 1) + ' of ' + RV.gallery.length + '</div><div class="ywv2-lb-cap">' + stars(r.reviewRating) + (r.reviewTitle ? '<b>' + h(r.reviewTitle) + '</b>' : '') + h(r.reviewMessage) +
      '<div class="ywv2-who">' + h(shortName(r.author)) + (r.location ? ' · ' + h(r.location) : '') + ' · ' + h(day(r.reviewDate || r.dateCreated)) + '</div></div>';
  }
  lb.addEventListener('click', function (e) { var n = e.target.closest('[data-lb]'); if (n) { lbAt = (lbAt + Number(n.getAttribute('data-lb')) + RV.gallery.length) % RV.gallery.length; drawPhoto(); } });
  lb.addEventListener('keydown', function (e) { if (RV.gallery.length < 2) return; if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { lbAt = (lbAt + (e.key === 'ArrowRight' ? 1 : -1) + RV.gallery.length) % RV.gallery.length; drawPhoto(); } });

  /* ---------------- 3. add to cart: sizes first ---------------- */
  var A = null; // { product, sel: {optIndex: value}, view }
  var SIZE_RE = /size/i, SOLE_RE = /color|colour|sole/i, STYLE_RE = /style|gender/i;
  function findVariant() {
    return A.product.variants.find(function (v) { return v.options.every(function (o, i) { return A.sel[i] === o; }); }) || null;
  }
  function valuesFor(i) {
    // Values of option i that exist (in any availability) given the other chosen options before it.
    var seen = []; A.product.variants.forEach(function (v) {
      for (var k = 0; k < i; k++) if (A.sel[k] != null && v.options[k] !== A.sel[k]) return;
      if (seen.indexOf(v.options[i]) < 0) seen.push(v.options[i]);
    }); return seen;
  }
  function availableWith(i, value) {
    return A.product.variants.some(function (v) {
      if (v.options[i] !== value || !v.available) return false;
      for (var k = 0; k < A.product.options.length; k++) if (k !== i && A.sel[k] != null && !SIZE_RE.test(A.product.options[k].name || A.product.options[k]) && v.options[k] !== A.sel[k]) return false;
      return true;
    });
  }
  function optName(o) { return typeof o === 'string' ? o : o.name; }
  function isSneaker() { return /sneaker/i.test(A.product.type || '') || /sneaker/i.test(A.product.title || ''); }
  function sizeLabel(v) { var p = String(v).split('/'); return { big: p[0].trim(), small: (p[1] || '').trim().replace(/^EU/i, 'EU ') }; }
  function drawAtc() {
    var p = A.product, body = atcPop.querySelector('[data-atc-body]'), foot = atcPop.querySelector('[data-atc-foot]');
    if (A.view === 'guide') {
      var style = A.guideStyle, unit = A.guideUnit, src = root.getAttribute('data-size-' + style + '-' + unit);
      body.innerHTML = '<button type="button" class="ywv2-back" data-back>‹ Back to sizes</button><div class="ywv2-chart"><div class="ywv2-row">' +
        '<div class="ywv2-seg"><button type="button" data-gs="women" aria-pressed="' + (style === 'women') + '">Women</button><button type="button" data-gs="men" aria-pressed="' + (style === 'men') + '">Men</button></div>' +
        '<div class="ywv2-seg"><button type="button" data-gu="inch" aria-pressed="' + (unit === 'inch') + '">Inch</button><button type="button" data-gu="cm" aria-pressed="' + (unit === 'cm') + '">CM</button></div></div>' +
        '<img src="' + h(src) + '" alt="' + (style === 'women' ? 'Women' : 'Men') + ' size chart"><p class="ywv2-fit">Our footwear is true to size and fits well on wide feet. Pick the size you normally wear. If they don\'t fit perfectly, we offer <b>100% FREE size replacement</b>.</p></div>';
      foot.innerHTML = '<button class="ywv2-go" data-back>Choose my size</button>';
      return;
    }
    var html = '';
    p.options.forEach(function (o, i) {
      var name = optName(o), vals = valuesFor(i);
      if (SIZE_RE.test(name)) {
        html += '<div class="ywv2-lbl">Size ' + (isSneaker() ? '<button type="button" class="ywv2-guide" data-guide>📏 Size guide</button>' : '') + '</div><div class="ywv2-sizes" role="group" aria-label="Size">' +
          vals.map(function (v) { var l = sizeLabel(v), ok = availableWith(i, v); return '<button type="button" data-opt="' + i + '" data-val="' + h(v) + '" aria-pressed="' + (A.sel[i] === v) + '"' + (ok ? '' : ' disabled') + '><b>' + h(l.big) + '</b>' + (l.small ? '<span>' + h(l.small) + '</span>' : '') + '</button>'; }).join('') + '</div>';
      } else if (vals.length > 1) {
        html += '<div class="ywv2-lbl">' + h(STYLE_RE.test(name) ? 'Style' : SOLE_RE.test(name) ? 'Sole colour' : name) + ' <span class="ywv2-val">' + h(A.sel[i] || '') + '</span></div><div class="ywv2-seg" role="group" aria-label="' + h(name) + '">' +
          vals.map(function (v) { return '<button type="button" data-opt="' + i + '" data-val="' + h(v) + '" aria-pressed="' + (A.sel[i] === v) + '">' + h(String(v).replace(/ Sneakers$/i, '').replace(/ Sole$/i, ' sole')) + '</button>'; }).join('') + '</div>';
      } else if (vals.length === 1) {
        A.sel[i] = vals[0];
        html += '<div class="ywv2-lbl">' + h(SOLE_RE.test(name) ? 'Sole colour' : name) + ' <span class="ywv2-val">' + h(vals[0]) + ' only on this design</span></div>';
      }
    });
    html += '<p class="ywv2-hint" data-hint></p>' + (isSneaker() ? '<div class="ywv2-fit"><b>True to size</b> and fits wide feet. Pick the size you normally wear. Not quite right? <b>FREE size replacement</b> on all footwear.</div>' : '');
    body.innerHTML = html;
    var v = findVariant();
    foot.innerHTML = '<button class="ywv2-go" data-add' + (v && v.available ? '' : ' aria-disabled="true"') + '>' + (v && v.available ? 'Add to cart · ' + money(v.price) : (v ? 'Sold out' : 'Select a size')) + '</button>';
  }
  function openAtc(card) {
    var handle = card.getAttribute('data-handle');
    atcPop.innerHTML = '<div class="ywv2-pop-hd"><img src="' + h(cardImg(card)) + '" alt=""><div><h2>' + h(card.getAttribute('data-title')) + '</h2><div class="ywv2-pop-sub" data-atc-sub></div></div><button class="ywv2-x" data-close aria-label="Close">×</button></div>' +
      '<div class="ywv2-pop-bd" data-atc-body><div class="ywv2-loading">Loading sizes…</div></div><div class="ywv2-pop-ft" data-atc-foot></div>';
    atcPop.showModal();
    A = null;
    var fromPage = productFromPage(handle, card.getAttribute('data-title'));
    (fromPage ? Promise.resolve(fromPage) : fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); })).then(function (p) {
      A = { product: p, sel: {}, view: 'pick', guideStyle: 'women', guideUnit: 'inch', card: card };
      // Pre-select every non-size option with its first value (as the product page does); the size is always the shopper's choice.
      p.options.forEach(function (o, i) { if (!SIZE_RE.test(optName(o))) A.sel[i] = p.variants[0].options[i]; });
      var sub = atcPop.querySelector('[data-atc-sub]'), v0 = p.variants[0];
      sub.innerHTML = (v0.compare_at_price > v0.price ? '<s>' + money(v0.compare_at_price) + '</s>' : '') + '<b>' + money(v0.price) + '</b>';
      drawAtc();
    }).catch(function () { atcPop.querySelector('[data-atc-body]').innerHTML = '<div class="ywv2-empty">Sizes could not load. <a href="/products/' + encodeURIComponent(handle) + '">Open the product page</a>.</div>'; });
  }
  atcPop.addEventListener('click', function (e) {
    if (!A) return;
    var t = e.target.closest('button'); if (!t) return;
    if (t.hasAttribute('data-opt')) {
      var i = Number(t.getAttribute('data-opt')), val = t.getAttribute('data-val');
      A.sel[i] = val;
      // Changing Style resets the size (women's and men's size runs differ).
      if (STYLE_RE.test(optName(A.product.options[i]))) A.product.options.forEach(function (o, k) { if (SIZE_RE.test(optName(o))) delete A.sel[k]; });
      if (STYLE_RE.test(optName(A.product.options[i]))) A.guideStyle = /men/i.test(val) && !/women/i.test(val) ? 'men' : 'women';
      drawAtc();
    } else if (t.hasAttribute('data-guide')) { A.view = 'guide'; drawAtc(); atcPop.querySelector('[data-atc-body]').scrollTop = 0; }
    else if (t.hasAttribute('data-back')) { A.view = 'pick'; drawAtc(); }
    else if (t.hasAttribute('data-gs')) { A.guideStyle = t.getAttribute('data-gs'); drawAtc(); }
    else if (t.hasAttribute('data-gu')) { A.guideUnit = t.getAttribute('data-gu'); drawAtc(); }
    else if (t.hasAttribute('data-add')) {
      var v = findVariant();
      if (!v || !v.available) { var hint = atcPop.querySelector('[data-hint]'); if (hint) hint.textContent = v ? 'That size is sold out. Pick another one.' : 'Pick your size first, then add to cart.'; return; }
      addToCart(v, A.card);
    }
  });

  /* ---------------- add + toast ---------------- */
  var toastEl = null, toastTimer = 0;
  function toast(html, ms) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'ywv2-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); document.body.appendChild(toastEl);
      toastEl.addEventListener('click', function (e) {
        if (e.target.closest('[data-toast-cart]')) { var d = document.querySelector('cart-drawer'); if (d && d.open) d.open(); else location.href = '/cart'; hideToast(); }
        if (e.target.closest('[data-toast-x]')) hideToast();
      });
    }
    toastEl.innerHTML = html; toastEl.classList.add('on');
    clearTimeout(toastTimer); if (ms) toastTimer = setTimeout(hideToast, ms);
  }
  function hideToast() { if (toastEl) toastEl.classList.remove('on'); }
  function addsSoFar() { try { return Number(sessionStorage.getItem('ywv2:adds')) || 0; } catch (e) { return 0; } }
  function countAdd() { var n = addsSoFar() + 1; try { sessionStorage.setItem('ywv2:adds', String(n)); } catch (e) {} return n; }
  // Replace the drawer's contents and the header count WITHOUT opening the drawer.
  function refreshDrawerSilently(drawer, sections) {
    drawer.getSectionsToRender().forEach(function (sec) {
      var el = sec.selector ? document.querySelector(sec.selector) : document.getElementById(sec.id);
      if (el && sections[sec.id]) el.innerHTML = drawer.getSectionInnerHTML(sections[sec.id], sec.selector);
    });
    var inner = drawer.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
    drawer.classList.remove('is-empty');
    var ov = drawer.querySelector('#CartDrawer-Overlay'); if (ov && !ov._ywv2) { ov._ywv2 = true; ov.addEventListener('click', drawer.close.bind(drawer)); }
  }
  function cartCountFrom(sections) {
    try { var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'] || '', 'text/html'); var b = doc.querySelector('.cart-count-bubble [aria-hidden]') || doc.querySelector('.cart-count-bubble'); return b ? parseInt(b.textContent, 10) || 0 : 0; } catch (e) { return 0; }
  }
  function cartIcon() {
    var el = document.getElementById('cart-icon-bubble');
    if (!el) return null;
    var r = el.getBoundingClientRect();
    return r.width && r.bottom > 0 && r.top < innerHeight ? el : null;
  }
  function bumpCart() {
    var el = cartIcon(); if (!el || !el.animate) return;
    el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.45)' }, { transform: 'scale(.9)' }, { transform: 'scale(1.08)' }, { transform: 'scale(1)' }], { duration: 560, easing: 'ease-out' });
    // green ring pulsing out of the cart icon
    var r = el.getBoundingClientRect(), ring = document.createElement('span');
    ring.className = 'ywv2-ring'; ring.setAttribute('aria-hidden', 'true');
    ring.style.cssText = 'left:' + (r.left + r.width / 2 - 22) + 'px;top:' + (r.top + r.height / 2 - 22) + 'px';
    document.body.appendChild(ring);
    ring.animate([{ transform: 'scale(.4)', opacity: .9 }, { transform: 'scale(1.9)', opacity: 0 }], { duration: 650, easing: 'ease-out', fill: 'forwards' }).onfinish = function () { ring.remove(); };
    setTimeout(function () { if (ring.parentNode) ring.remove(); }, 1000);
  }
  // The shoe lifts off from where the shopper is looking (the popup's photo, else the card),
  // pops up, then flies on an arc into the header cart icon. X runs on the outer box and Y on
  // the inner image with different easings, which draws the curve. Returns a promise that
  // resolves when it lands (so the toast / drawer can wait for it).
  function flyToCart(card, from) {
    var img = card && card.querySelector('.ywv2-img'), target = cartIcon();
    var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!img || !document.body.animate) { bumpCart(); return Promise.resolve(); }
    // Cart icon on screen: land on it. Scrolled away / missing: land in the top-right corner,
    // which is where the cart lives, so the shopper still sees the shoe "go to the cart".
    var b = target ? target.getBoundingClientRect() : { left: innerWidth - 64, top: 14, width: 36, height: 36 };
    var a = from && from.width ? from : img.getBoundingClientRect();
    if (!a.width || a.bottom < 0 || a.top > innerHeight) { a = { left: innerWidth / 2 - 90, top: innerHeight / 2 - 52, width: 180, height: 105 }; }
    var ratio = (img.naturalHeight && img.naturalWidth) ? img.naturalHeight / img.naturalWidth : .58;
    var w = Math.max(150, Math.min(220, a.width)), hgt = w * ratio;
    var x0 = a.left + a.width / 2 - w / 2, y0 = a.top + a.height / 2 - hgt / 2;
    var dx = b.left + b.width / 2 - (x0 + w / 2), dy = b.top + b.height / 2 - (y0 + hgt / 2);
    var outer = document.createElement('div'), inner = document.createElement('img');
    outer.className = 'ywv2-fly'; outer.setAttribute('aria-hidden', 'true');
    outer.style.cssText = 'left:' + x0 + 'px;top:' + y0 + 'px;width:' + w + 'px;height:' + hgt + 'px';
    inner.src = img.currentSrc || img.src; inner.alt = '';
    outer.appendChild(inner); document.body.appendChild(outer);
    var lift = still ? 0 : 260, ms = still ? 520 : 1000;
    var xAnim = outer.animate([{ transform: 'translateX(0)', offset: 0 }, { transform: 'translateX(0)', offset: lift / (lift + ms) }, { transform: 'translateX(' + dx + 'px)' }],
      { duration: lift + ms, easing: 'linear', fill: 'forwards' });
    var yFrames = still ? [
      { transform: 'translateY(0) scale(1)', opacity: 1 },
      { transform: 'translateY(' + dy + 'px) scale(.15)', opacity: .6 }
    ] : [
      { transform: 'translateY(0) scale(.95) rotate(0)', opacity: 1, offset: 0, easing: 'cubic-bezier(.2,1.4,.4,1)' },
      { transform: 'translateY(-14px) scale(1.12) rotate(-4deg)', opacity: 1, offset: .2, easing: 'ease-in-out' },
      { transform: 'translateY(-60px) scale(.95) rotate(-10deg)', opacity: 1, offset: .45, easing: 'cubic-bezier(.55,0,1,.6)' },
      { transform: 'translateY(' + dy + 'px) scale(.14) rotate(14deg)', opacity: .85, offset: 1 }
    ];
    var fly = inner.animate(yFrames, { duration: lift + ms, easing: still ? 'ease-in' : 'linear', fill: 'forwards' });
    return new Promise(function (done) {
      var landed = false;
      function land() { if (landed) return; landed = true; outer.remove(); bumpCart(); done(); }
      fly.onfinish = land; xAnim.onfinish = null;
      setTimeout(land, lift + ms + 300); // background tab / timeline paused: never hang the cart
    });
  }
  function addToCart(v, card) {
    // Optimistic: the popup closes the moment the shopper taps; the cart catches up behind.
    var ph = atcPop.querySelector('.ywv2-pop-hd img'), from = ph ? ph.getBoundingClientRect() : null;
    atcPop.close();
    var landed = flyToCart(card, from);
    var title = card ? card.getAttribute('data-title') : '';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: v.id, quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (x) { return x.id; }); body.sections_url = location.pathname; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add');
        var n = countAdd(), sections = res.j.sections || {};
        if (drawer && res.j.sections) refreshDrawerSilently(drawer, sections);
        return landed.then(function () {
        if (drawer && drawer.renderContents && res.j.sections && n % 4 === 0) {
          // Every 4th add: show the full drawer (with its BOGO message) once.
          hideToast(); drawer.renderContents(Object.assign({ id: v.id }, res.j)); return;
        }
        var count = cartCountFrom(sections), bogo = card && card.querySelector('.ywv2-bogo');
        var nudge = bogo && count ? (count % 2 ? '<small>Add another pair, it\'s <b>FREE</b></small>' : '<small>Your free pair is in 🎉</small>') : '';
        toast('<span class="ywv2-toast-ok" aria-hidden="true">✓</span><span class="ywv2-toast-txt"><b>Added to cart</b>' + nudge + '</span>' +
          '<button type="button" class="ywv2-toast-btn" data-toast-cart>View cart</button><button type="button" class="ywv2-toast-x" data-toast-x aria-label="Close">×</button>', 5000);
        });
      })
      .catch(function (err) {
        toast('<span class="ywv2-toast-err" aria-hidden="true">!</span><span class="ywv2-toast-txt"><b>Couldn\'t add that</b><small>' + h(String(err.message || err)) + '</small></span><button type="button" class="ywv2-toast-x" data-toast-x aria-label="Close">×</button>', 7000);
      });
  }

  /* ---------------- hover photo, on demand ---------------- */
  root.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var card = e.target.closest && e.target.closest('[data-ywv2-card][data-img2]');
    if (!card || card._img2) return;
    card._img2 = true;
    var link = card.querySelector('.ywv2-media-link'); if (!link) return;
    var im = document.createElement('img');
    im.className = 'ywv2-img ywv2-img2'; im.alt = ''; im.setAttribute('aria-hidden', 'true'); im.decoding = 'async';
    im.sizes = '(min-width: 990px) 26vw, 48vw'; im.srcset = card.getAttribute('data-img2-srcset'); im.src = card.getAttribute('data-img2');
    im.onload = function () { card.classList.add('ywv2-has2'); };
    link.appendChild(im);
  });

  /* ---------------- clicks on cards ---------------- */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ywv2-atc]'), r = e.target.closest('[data-ywv2-reviews]');
    if (a) { e.preventDefault(); openAtc(cardOf(a)); }
    else if (r) { e.preventDefault(); openReviews(cardOf(r)); }
  });

  /* ---------------- 4. load more ---------------- */
  var grid = root.querySelector('[data-ywv2-grid]');
  var KEY = 'ywv2:' + location.pathname;
  function nextLink() { return root.querySelector('[data-ywv2-next]'); }
  function loadPage(url) {
    var sid = root.getAttribute('data-section-id');
    var u = url + (url.indexOf('?') < 0 ? '?' : '&') + 'section_id=' + encodeURIComponent(sid);
    return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      readTypes(doc); readVariants(doc);
      var items = doc.querySelectorAll('[data-ywv2-grid] > li'), frag = document.createDocumentFragment();
      [].forEach.call(items, function (li) { frag.appendChild(document.importNode(li, true)); });
      grid.appendChild(frag);
      var newNext = doc.querySelector('[data-ywv2-next]'), more = root.querySelector('[data-ywv2-more]'), shown = root.querySelector('[data-ywv2-shown]');
      var count = grid.children.length, total = Number(root.getAttribute('data-total')) || count;
      if (shown) shown.textContent = 'Showing ' + Math.min(count, total) + ' of ' + total;
      if (newNext) { var btn = nextLink(); btn.setAttribute('href', newNext.getAttribute('href')); btn.setAttribute('data-ywv2-next', newNext.getAttribute('data-ywv2-next')); }
      else if (more) { var b = nextLink(); if (b) b.remove(); if (shown) shown.textContent = 'You have seen all ' + total + ' designs'; }
      return loadStars(grid);
    });
  }
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ywv2-next]'); if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Loading…';
    var url = btn.getAttribute('data-ywv2-next');
    loadPage(url).then(function () {
      var s = readState(); s.pages.push(url); writeState(s);
      var b = nextLink(); if (b) { b.removeAttribute('aria-busy'); b.textContent = 'Load more designs'; }
    }).catch(function () { location.href = url; });
  });

  // Coming Back from a product page: reload the extra pages, then return to the same spot.
  function readState() { try { return JSON.parse(sessionStorage.getItem(KEY)) || { pages: [], y: 0 }; } catch (e) { return { pages: [], y: 0 }; } }
  function writeState(s) { try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  var saveTimer = 0;
  window.addEventListener('scroll', function () { clearTimeout(saveTimer); saveTimer = setTimeout(function () { var s = readState(); s.y = window.scrollY; writeState(s); }, 150); }, { passive: true });
  var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
  var state = readState();
  if (nav.type === 'back_forward' && state.pages.length && !/[?&]page=/.test(location.search)) {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    state.pages.reduce(function (p, url) { return p.then(function () { return loadPage(url); }); }, Promise.resolve())
      .then(function () { window.scrollTo(0, state.y || 0); });
  } else {
    writeState({ pages: [], y: 0 });
  }

  loadStars(root);
})();
